// @flow
import userSchema from "src/schemas/userSchema";
import { relationshipReducer } from "src/utils/reducerUtils";

export const userRelationships = relationshipReducer({
  name: "users",
  relationshipSchemas: userSchema.relationshipSchemas
});
